import React from 'react'
import { useState } from 'react'
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from '../Projects/ProjectsStyle'
import ProjectCard from '../Cards/ProjectCard'
import { projects } from '../../data/Constants'


const Projects = ({openModal,setOpenModal}) => {
  const [toggle, setToggle] = useState('all');
  return (
    <Container id="projects">
      <Wrapper>
        <Title>Projects</Title>
        <Desc>
          I have worked on a wide range of projects. From web apps to android apps. Here are some of my projects.
        </Desc>
        <ToggleButtonGroup >
          {toggle === 'all' ?
            <ToggleButton active value="all" onClick={() => setToggle('all')}>All</ToggleButton>
            :
            <ToggleButton value="all" onClick={() => setToggle('all')}>All</ToggleButton>
          }
          <Divider />
          {toggle === 'ReactJS' ?
            <ToggleButton active value="ReactJS" onClick={() => setToggle('ReactJS')}>ReactJS</ToggleButton>
            :
            <ToggleButton value="ReactJS" onClick={() => setToggle('ReactJS')}>ReactJS</ToggleButton>
          }
          <Divider />
          {toggle === 'AngularJS' ?
            <ToggleButton active value="AngularJS" onClick={() => setToggle('AngularJS')}>AngularJS</ToggleButton>
            :
            <ToggleButton value="AngularJS" onClick={() => setToggle('AngularJS')}>AngularJS</ToggleButton>
          }
          <Divider />
          {toggle === 'python' ?
            <ToggleButton active value="python" onClick={() => setToggle('python')}>Python</ToggleButton>
            :
            <ToggleButton value="python" onClick={() => setToggle('python')}>Python</ToggleButton>
          }
          <Divider />
          {toggle === 'others' ?
            <ToggleButton active value="others" onClick={() => setToggle('others')}>Others</ToggleButton>
            :
            <ToggleButton value="others" onClick={() => setToggle('others')}>Others</ToggleButton>
          }
        </ToggleButtonGroup>
        <CardContainer>
          {toggle === 'all' && projects
            .map((project,index) => (
              <ProjectCard key={index} project={project} openModal={openModal} setOpenModal={setOpenModal}/>
            ))}
          {projects
            .filter((item) => item.category === toggle)
            .map((project) => (
              <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal}/>
            ))}
        </CardContainer>
      </Wrapper>
    </Container>
  )
}

export default Projects